export default __webpack_public_path__ + "static/media/pelzerlogo.8a4c4338.png";